// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dateWidth_OIrz8 {
  position: absolute;
  width: 100%;
  top: 0px !important;
}
.datePicker_QvIRc {
  padding-bottom: 1.5cm;
}
.services_XCCtS {
  padding-bottom: 1.5cm;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Clients/RegisteredClients/Partnership/Buttons/Partneship services/Partnershipserviceless.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACA;EACI,qBAAA;AACJ;AAEA;EACI,qBAAA;AAAJ","sourcesContent":[".dateWidth {\n    position: absolute;\n    width: 100%;\n    top: 0px !important;\n}\n.datePicker {\n    padding-bottom: 1.5cm;\n}\n\n.services {\n    padding-bottom: 1.5cm;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateWidth": `dateWidth_OIrz8`,
	"datePicker": `datePicker_QvIRc`,
	"services": `services_XCCtS`
};
export default ___CSS_LOADER_EXPORT___;
